
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import DetailDrinksScreens from './detailDrinks'

function Index({setshowCategories}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const [menus, setMenus] = useState([]);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showDrinks, setShowDrinks] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
     const [dishs, setdishs] = useState(false);
    const [drinks, setdrinks] = useState(false);
    const [type, setType] = useState(false);
    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
    }, []);



    
          useEffect(() => {
                menus.map((item) => {
                    if (item.id === 479) {
                        setdrinks(item);
                    }
                });
          }, [menus]);
        
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} setShowListProduct={setshowCategories} goHome={setshowCategories} setShowSpecials={() => {
             setShowSpecials(true)
        }}>
                <div  style={{padding: '0 20px', overflow: 'scroll', height: 765}}>
                    <div style={{display:"flex", justifyContent: 'space-between', flexWrap: "wrap"}}>
                       <div
                            style={{
                                width: '100%',
                                paddingInline: 20,
                                display:"flex",
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                paddingHorizontal: 20,
                            }}>
                            <div
                            onClick={() =>
                                {
                                    setShowDrinks(true)
                                    setType('mexicam')
                            }
                            }
                            style={{justifyContent: 'center', alignItems: 'center', position: 'relative', display: 'flex'}}>
                            <img
                                src={require('./assets/btn.png')}
                                style={{
                                marginTop: 20,
                                width: 300,
                                height: 200,
                                objectFit: 'contain',
                                borderRadius: 40,
                                alignSelf: 'center',
                                }}
                            />
                            <p
                                style={{
                                color: 'white',
                                position: 'absolute',
                                fontSize: 25,
                                fontFamily: 'Roadstore',
                                width: '60%',
                                        textAlign: 'center',
                                marginTop: 10,
                                }}>
                                Mex Sodas <br/> jarritos
                            </p>
                            </div>
                            <div
                            onClick={() =>
                                {
                                   setShowDrinks(true)
                                    setType('aguanatural')
                            }
                            }
                            style={{justifyContent: 'center', alignItems: 'center',  position: 'relative', display: 'flex'}}>
                            <img
                                src={require('./assets/btn.png')}
                                style={{
                                marginTop: 20,
                                width: 300,
                                height: 200,
                                objectFit: 'contain',
                                borderRadius: 40,
                                alignSelf: 'center',
                                }}
                            />
                            <p
                                style={{
                                color: 'white',
                                position: 'absolute',
                                fontSize: 25,
                                fontFamily: 'Roadstore',
                                width: '100%',
                                textAlign: 'center',
                                }}>
                                famous mexican <br/>waters
                                </p>
                                
                                <p
                                style={{
                                color: '#FE9C0A',
                                        position: 'absolute',
                                bottom: 50,
                                fontSize: 25,
                                fontFamily: 'Roadstore',
                                width: '100%',
                                        textAlign: 'center',
                                
                                }}>
                                Aguas mexicanas
                            </p>
                            </div>
                        </div>

                    </div>

                    <div style={{display:"flex", justifyContent: 'space-between', flexWrap: "wrap"}}>
                       <div
                            style={{
                                width: '100%',
                                paddingInline: 20,
                                display:"flex",
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                paddingHorizontal: 20,
                            }}>
                            <div
                             onClick={() =>
                                {
                                   setShowDrinks(true)
                                    setType('jugosnatural')
                            }
                            }
                            style={{justifyContent: 'center', alignItems: 'center', position: 'relative', display: 'flex'}}>
                            <img
                                src={require('./assets/btn.png')}
                                style={{
                                marginTop: 20,
                                width: 300,
                                height: 200,
                                objectFit: 'contain',
                                borderRadius: 40,
                                alignSelf: 'center',
                                }}
                                />
                                
                                 <p
                                style={{
                               color: 'white',
                                position: 'absolute',
                                fontSize: 25,
                                fontFamily: 'Roadstore',
                                width: '100%',
                                textAlign: 'center',
                                }}>
                               natural juices
                                </p>
                                
                            <p
                                style={{
                                color: '#EBB234',
                                position: 'absolute',
                                fontSize: 25,
                                fontFamily: 'Roadstore',
                                width: '100%',
                                        textAlign: 'center',
                                bottom: 60
                                }}>
                               Jugos Naturales
                            </p>
                            </div>
                            <div
                            onClick={() =>
                                {
                                   setShowDrinks(true)
                                    setType('batidos')
                            }
                            }
                            style={{justifyContent: 'center', alignItems: 'center',  position: 'relative', display: 'flex'}}>
                            <img
                                src={require('./assets/btn.png')}
                                style={{
                                marginTop: 20,
                                width: 300,
                                height: 200,
                                objectFit: 'contain',
                                borderRadius: 40,
                                alignSelf: 'center',
                                }}
                            />
                             <p
                                style={{
                               color: 'white',
                                position: 'absolute',
                                fontSize: 25,
                                fontFamily: 'Roadstore',
                                width: '100%',
                                textAlign: 'center',
                                }}>
                              healthy shakers
                                </p>
                                
                            <p
                                style={{
                                color: '#EBB234',
                                position: 'absolute',
                                fontSize: 24,
                                fontFamily: 'Roadstore',
                                width: '100%',
                                        textAlign: 'center',
                                bottom: 60
                                }}>
                              batidos naturales
                            </p>
                            </div>
                        </div>

                    </div>

                    <div style={{display:"flex", justifyContent: 'space-between', flexWrap: "wrap"}}>
                       <div
                            style={{
                                width: '100%',
                                paddingInline: 20,
                                display:"flex",
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                paddingHorizontal: 20,
                            }}>
                            <div
                            onClick={() =>
                                {
                                   setShowDrinks(true)
                                    setType('limonadas')
                            }
                            }
                            style={{justifyContent: 'center', alignItems: 'center', position: 'relative', display: 'flex'}}>
                            <img
                                src={require('./assets/btn.png')}
                                style={{
                                marginTop: 20,
                                width: 300,
                                height: 200,
                                objectFit: 'contain',
                                borderRadius: 40,
                                alignSelf: 'center',
                                }}
                            />
                            <p
                                style={{
                               color: 'white',
                                position: 'absolute',
                                fontSize: 25,
                                fontFamily: 'Roadstore',
                                width: '100%',
                                textAlign: 'center',
                                }}>
                             lemonades

                                </p>
                                
                            <p
                                style={{
                                color: '#EBB234',
                                position: 'absolute',
                                fontSize: 24,
                                fontFamily: 'Roadstore',
                                width: '100%',
                                        textAlign: 'center',
                                bottom: 60
                                }}>
                              limonadas
                            </p>
                            </div>
                            <div
                            onClick={() =>
                                {
                                   setShowDrinks(true)
                                    setType('hotdrink')
                            }
                            }
                            style={{justifyContent: 'center', alignItems: 'center',  position: 'relative', display: 'flex'}}>
                            <img
                                src={require('./assets/btn.png')}
                                style={{
                                marginTop: 20,
                                width: 300,
                                height: 200,
                                objectFit: 'contain',
                                borderRadius: 40,
                                alignSelf: 'center',
                                }}
                            />
                            <p
                                style={{
                               color: 'white',
                                position: 'absolute',
                                fontSize: 25,
                                fontFamily: 'Roadstore',
                                width: '100%',
                                textAlign: 'center',
                                }}>
                             hot drinks


                                </p>
                                
                            <p
                                style={{
                                color: '#EBB234',
                                position: 'absolute',
                                fontSize: 24,
                                fontFamily: 'Roadstore',
                                width: '100%',
                                        textAlign: 'center',
                                bottom: 60
                                }}>
                              bebidas calientes
                            </p>
                            </div>
                        </div>

                    </div>
                   
                </div>

                {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct}
                    goHome={setshowCategories}
                />}

                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setshowCategories} />}
                 {showDrinks && <DetailDrinksScreens setshowCategories={setShowDrinks} type={type} goBack={setShowDrinks}  goHome={setshowCategories} />}
            </LayoutContent>
        </div>
    );
}
export default Index;